export default "__VITE_ASSET__fd4053b6__"